import { render, staticRenderFns } from "./provider-filters.vue?vue&type=template&id=3837d2db&"
import script from "./provider-filters.vue?vue&type=script&lang=js&"
export * from "./provider-filters.vue?vue&type=script&lang=js&"
import style0 from "./provider-filters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports